import { createApiV2 } from "./common";

export const getOrderStatus = () => (token) => createApiV2("GET", "status/")(token);

export default {};
